/**
 * Typed projections over state.infoPane.
 *
 * The slice itself lives at redux_store/slices/infoPaneSlice.js for now;
 * relocating it into FSD is a follow-up. These selectors are the single
 * read-side API the widget components use.
 */
export const selectCurrentPage = state => state.infoPane.currentPage;
export const selectCurrentPageName = state => state.infoPane.currentPage?.currentPageName;
export const selectCurrentPageContext = state => state.infoPane.currentPage?.currentPageContext;
export const selectCurrentPageData = state => state.infoPane.currentPage?.currentPageData;
export const selectIsExpanded = state => state.infoPane.isInfoPaneExpanded;
export const selectHistory = state => state.infoPane.history;

// Resolve the current page's position inside the history by uuid
// rather than reading the cached `indexInHistory` field. The slice
// sets that field at insert time but does not refresh it when
// history shifts (>10 entries) or when entries are mutated in place
// via setCurrentPageContext — both cases leave a stale index that
// can disable the back / forward arrows when navigation is still
// valid. Walking the array on each selector run is cheap (max 10
// entries) and always reflects the true history shape.
const selectCurrentIndex = state => {
  const uuid = state.infoPane.currentPage?.uuid;
  if (!uuid) return -1;
  return state.infoPane.history.findIndex(p => p?.uuid === uuid);
};

export const selectCanGoBack = state => selectCurrentIndex(state) > 0;

export const selectCanGoForward = state => {
  const idx = selectCurrentIndex(state);
  const len = state.infoPane.history?.length ?? 0;
  return idx >= 0 && idx < len - 1;
};
